import React from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "../../../styles/colors";
import { fonts } from "../../../styles/theme";

interface StatChipProps {
  /** Formatierter Wert (z.B. "5", "30,0 MW") */
  value: string;
  /** Optionaler Label-Text rechts neben dem Wert */
  label?: string;
  /** Pastell-Hintergrundfarbe aus dem Farbsystem */
  backgroundColor: string;
  /** Textfarbe für den Wert */
  valueColor: string;
  /** Wert in fetter statt halbfetter Schrift darstellen (z.B. für den Gesamtstatus) */
  bold?: boolean;
}

/**
 * Kompakter Pastell-Chip für Kennzahlen in Section-Headern
 */
const StatChip: React.FC<StatChipProps> = ({
  value,
  label,
  backgroundColor,
  valueColor,
  bold = false,
}) => (
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "baseline",
      gap: 0.75,
      px: 1.5,
      py: 0.5,
      borderRadius: "10px",
      backgroundColor,
    }}
  >
    <Typography
      sx={{
        fontSize: "0.95rem",
        fontWeight: bold ? fonts.weights.bold : fonts.weights.semiBold,
        fontFamily: '"JetBrains Mono", "Fira Code", monospace',
        lineHeight: 1,
        color: valueColor,
      }}
    >
      {value}
    </Typography>
    {label && (
      <Typography
        sx={{
          fontSize: "0.75rem",
          fontWeight: fonts.weights.medium,
          color: colors.text.secondary,
        }}
      >
        {label}
      </Typography>
    )}
  </Box>
);

export default StatChip;
